import { colors, fonts, glyphs } from "../../../Styles";
import { useTranslation } from "react-i18next";
import { systemControleTypes, useLfContext } from "../Modals/_Modals/lfPenContext";

interface ActivePensListProps {
  focus_view?: boolean;
}

export function ActivePensList({ focus_view }: ActivePensListProps) {
  const { t } = useTranslation();
  const { state: { selectedPens, nextFeeding_LocationsToFeed, selectedSection, locationResults, systemControlePen } } = useLfContext();
  
  if (!selectedPens || selectedPens.length === 0) return;

  return ( selectedPens.map((pen) => {
    const _toFeed = !!nextFeeding_LocationsToFeed?.some(loc => loc.location_id === pen.location_id);
    const dimmed = systemControlePen && systemControlePen.systemControleType === systemControleTypes.startSection && !_toFeed;
    
    return (
      <div key={"pen_" + pen.location_id} style={{ display: "grid", gridTemplateColumns: "80px 15px 1fr 1fr", gridTemplateRows: "1fr", gap: "10px", opacity: dimmed ? "0.5" : "1"}}>
        <p key={'name_' + pen.location_id} style={{ gridArea: "1/1/2/2", height: "20px", ...fonts.paragraph, ...(focus_view ? fonts.fontSize3 : fonts.fontSize4), color: colors.greyDarkPrimary }}>
          {`${t("locationFeederPages.locationFeeder.pen", { defaultValue: "Pen" })} ${selectedSection?.section_locations.find(loc => loc.location_id === pen.location_id)?.name}`}
        </p>
        {locationResults !== undefined && locationResults[pen.location_id] !== undefined &&
          <div key={'res_' + pen.location_id} style={{ gridArea: "1/2/2/3", height: "15px", display: "flex", alignItems: "center", justifyContent: "center" }}>
            {locationResults[pen.location_id]
              ? <glyphs.Check fillColor={colors.systemGreen} size={"20px"} /> 
              : <glyphs.Empty fillColor={colors.systemRed} size={"20px"} />
            }
          </div>
        }
      </div>
      )
    })
  );
}
